import { ReactComponent as SpriteSvg } from './sprite.svg'

export function IconsSpriteContainer() {
  return (
    <div style={{ display: 'none' }}>
      <SpriteSvg />
    </div>
  )
}
